<template>
  <div>
    <v-fab-transition>
      <v-btn
          class="but-class"
          bottom
          right
          fixed
          fab
          @click="show = true"
      >
          <span>
            {{ current === -1 ? '分区' : classifyList[current].label }}
          </span>
      </v-btn>
    </v-fab-transition>


    <v-dialog v-model="show" max-width="300" persistent>
      <v-card>
        <v-list>
          <v-list-item-group v-model="select" mandatory>
            <v-list-item
                v-for="(item, i) in classifyList"
                :key="i"
            >
              <v-list-item-content>
                <v-list-item-title v-text="item.label"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="green darken-1"
              text
              @click="send"
          >
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
export default {
  name: "imgClassifySelect",
  model: {
    props: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Number,
      default: undefined
    }
  },

  data: () => ({
    show: false,
    select: 0,
    classifyList: [
      {
        value: 2,
        label: '500px'
      },
      {
        value: 3,
        label: '500px'
      }
    ],
  }),

  computed: {
    current() {
      return this.classifyList.findIndex(item => item.value === this.value)
    }
  },

  mounted() {
    this.select = this.current ===  -1 ? this.current : 0
  },
  methods: {
    send() {
      this.$emit('change', this.classifyList[this.select].value)
      this.show = false;
      // this.$parent._list()
    }
  }
}
</script>

<style scoped>
.but-class {
  bottom: 136px;
}
</style>
